import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './keycloak-info.magic.css.js';
import script from './keycloak-info.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.message)?_c('magic-ui-text',{staticClass:"description",attrs:{"is-markdown":"","tag":"p","part":"description","content":_vm.message.summary}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},[(!_vm.skipLink && _vm.pageRedirectUri !== undefined)?_c('magic-ui-link',{attrs:{"button":"","wide":"","variant":"primary","to":_vm.pageRedirectUri},domProps:{"innerHTML":_vm._s(_vm.$t('keycloak-info-back.button'))}}):(_vm.actionUri)?_c('magic-ui-link',{attrs:{"button":"","wide":"","variant":"primary","to":_vm.actionUri},domProps:{"innerHTML":_vm._s(_vm.$t('keycloak-info-action.button'))}}):(_vm.baseUrl)?_c('magic-ui-link',{attrs:{"button":"","wide":"","variant":"primary","to":_vm.RoutablePage.HOME},domProps:{"innerHTML":_vm._s(_vm.$t('keycloak-info-back.button'))}}):_vm._e()],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1e790a54_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-1e790a54";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
